import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NGXLogger } from 'ngx-logger';
import { map } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

import { myReportListRequest, myReportListResponse } from './my-report.actions';
import { ReportService } from '../../services/report.service';

@Injectable()
export class MyReportEffects {
  constructor(
    private actions$: Actions,
    private logger: NGXLogger,
    private reportService: ReportService
  ) {}

  myReportListRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(myReportListRequest),
      tap(() => this.logger.debug(`@Effect My Report Request`)),
      switchMap(({ payload }) => {
        return this.reportService.searchMyReport(payload).pipe(
          map((response) => {
            return myReportListResponse({
              data: response
            });
          })
        );
      })
    );
  });
}
